import { formatters } from '@/utils/intl/dateTimeFormatters'
import { SunFilled, MoonFilled, HomeFilled } from '@ant-design/icons'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { DriverFlags } from '../../DriverFlags'
import { checkIsDriverOffline } from '../../../util'
import type { DriverSchedule } from '../../../types'
import { Card } from 'antd'

type DriverScheduleCardProps = {
  driverSchedule: DriverSchedule
  showFlags?: boolean
}

export function DriverHeaderCard({ driverSchedule, showFlags }: DriverScheduleCardProps) {
  const started = !!driverSchedule?.last_update?.last_heartbeat
  const isOffline = checkIsDriverOffline(driverSchedule?.last_update?.last_heartbeat, driverSchedule?.complete)

  return (
    <Card className='driver-info-card' classNames={{ body: 'pt-1 pb-3 px-3' }}>
      <Horizontal justifyContent='space-between' alignItems='center' className='pb-1 mb-2'>
        <Texto category='h3' weight='bold' className='driver-name mt-2'>
          {driverSchedule.driver_name}
        </Texto>
        {showFlags && (
          <DriverFlags
            hasNoGPS={driverSchedule.breadcrumbs?.length === 0 && started}
            isOffline={isOffline}
            lastHeartbeat={driverSchedule.last_update?.last_heartbeat}
            timezone={driverSchedule.timezone}
          />
        )}
      </Horizontal>
      <Horizontal justifyContent='space-between' className='mt-2'>
        <Horizontal>
          {driverSchedule.shift === 'am' ? <SunFilled className='shift-icon' /> : <MoonFilled className='shift-icon' />}
          <Texto className='ml-2'>
            {formatters.TIME(driverSchedule.shift_start, driverSchedule.timezone)} -{' '}
            {formatters.TIME(driverSchedule.shift_end, driverSchedule.timezone)}
          </Texto>
        </Horizontal>
        <Texto>
          <HomeFilled className='mr-1' /> {driverSchedule.depot_name}
        </Texto>
      </Horizontal>
    </Card>
  )
}
